var _linearGradient, _linearGradient2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogsIconWikimedia(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      display: "inline",
      enableBackground: "new"
    },
    height: 128,
    width: 128,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    y2: 72,
    x2: 340,
    y1: 76,
    x1: 344,
    gradientTransform: "matrix(.25 0 0 .25 180 83)",
    gradientUnits: "userSpaceOnUse",
    id: "e",
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#d5d3cf",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#fff",
      stopOpacity: 1
    }
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    y2: -180,
    x2: 256,
    y1: 268,
    x1: 256,
    gradientUnits: "userSpaceOnUse",
    id: "c",
    xlinkHref: "#b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#eeeeec",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#fff",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e74747",
      stroke: "none",
      strokeWidth: ".25px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    d: "m252 116 28-28v-8h-36v36z"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -172)",
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-.3 0 0 -.2128 -12.8 247.363)",
    style: {
      display: "inline",
      fill: "url(#c)",
      fillOpacity: 1,
      strokeWidth: 1.0298574,
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    ry: 44.432,
    rx: 26.667,
    y: -190.965,
    x: -429.333,
    height: 451.133,
    width: 346.667,
    style: {
      opacity: 1,
      vectorEffect: "none",
      fill: "#1a5fb4",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 53.73949814,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      marker: "none",
      markerStart: "none",
      markerMid: "none",
      markerEnd: "none",
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 1,
      vectorEffect: "none",
      fill: "#d5d3cf",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 53.73949814,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      marker: "none",
      markerStart: "none",
      markerMid: "none",
      markerEnd: "none",
      paintOrder: "normal"
    },
    width: 346.667,
    height: 451.133,
    x: -429.333,
    y: -181.566,
    rx: 26.667,
    ry: 44.432
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 1,
      vectorEffect: "none",
      fill: "#f6f5f4",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 53.73949814,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      marker: "none",
      markerStart: "none",
      markerMid: "none",
      markerEnd: "none",
      paintOrder: "normal"
    },
    width: 346.667,
    height: 451.133,
    x: -429.333,
    y: -153.371,
    rx: 26.667,
    ry: 37.594
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline",
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("circle", {
    r: 2,
    cy: 252,
    cx: 108,
    style: {
      opacity: 1,
      vectorEffect: "none",
      fill: "#d5d3cf",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 7.99999905,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      opacity: 1,
      vectorEffect: "none",
      fill: "#d5d3cf",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 7.99999905,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    },
    cx: 108,
    cy: 242,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    r: 2,
    cy: 232,
    cx: 108,
    style: {
      opacity: 1,
      vectorEffect: "none",
      fill: "#d5d3cf",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 7.99999905,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      opacity: 1,
      vectorEffect: "none",
      fill: "#d5d3cf",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 7.99999905,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    },
    cx: 108,
    cy: 222,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    r: 2,
    cy: 212,
    cx: 108,
    style: {
      opacity: 1,
      vectorEffect: "none",
      fill: "#d5d3cf",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 7.99999905,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      opacity: 1,
      vectorEffect: "none",
      fill: "#d5d3cf",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 7.99999905,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    },
    cx: 108,
    cy: 202,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    r: 2,
    cy: 192,
    cx: 108,
    style: {
      opacity: 1,
      vectorEffect: "none",
      fill: "#d5d3cf",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 7.99999905,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline",
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      opacity: 1,
      vectorEffect: "none",
      fill: "#d5d3cf",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 7.99999905,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    },
    cx: 20,
    cy: 272,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    r: 2,
    cy: 262,
    cx: 20,
    style: {
      opacity: 1,
      vectorEffect: "none",
      fill: "#d5d3cf",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 7.99999905,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      opacity: 1,
      vectorEffect: "none",
      fill: "#d5d3cf",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 7.99999905,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    },
    cx: 20,
    cy: 252,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    r: 2,
    cy: 242,
    cx: 20,
    style: {
      opacity: 1,
      vectorEffect: "none",
      fill: "#d5d3cf",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 7.99999905,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      opacity: 1,
      vectorEffect: "none",
      fill: "#d5d3cf",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 7.99999905,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    },
    cx: 20,
    cy: 232,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    r: 2,
    cy: 222,
    cx: 20,
    style: {
      opacity: 1,
      vectorEffect: "none",
      fill: "#d5d3cf",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 7.99999905,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      opacity: 1,
      vectorEffect: "none",
      fill: "#d5d3cf",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 7.99999905,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    },
    cx: 20,
    cy: 212,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    r: 2,
    cy: 202,
    cx: 20,
    style: {
      opacity: 1,
      vectorEffect: "none",
      fill: "#d5d3cf",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 7.99999905,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      opacity: 1,
      vectorEffect: "none",
      fill: "#d5d3cf",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 7.99999905,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    },
    cx: 20,
    cy: 192,
    r: 2
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline",
      opacity: 0.3,
      stroke: "#d5d3cf",
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28 192h72M28 202h72M28 212h72M28 222h72M28 232h72M28 242h72M28 252h72M28 262h72M28 272h66",
    style: {
      fill: "none",
      fillRule: "evenodd",
      stroke: "#d5d3cf",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(0 -1)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-20)",
    style: {
      display: "inline",
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(14 -12)",
    style: {
      opacity: 0.1,
      stroke: "#00000f",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "none",
      stroke: "#00000f",
      strokeWidth: 6,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1,
      enableBackground: "new"
    },
    d: "m36 250-8 8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28 258-14 14",
    style: {
      display: "inline",
      fill: "none",
      stroke: "#00000f",
      strokeWidth: 12,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1,
      enableBackground: "new"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    r: 30.118,
    cy: 228,
    cx: 58,
    style: {
      opacity: 1,
      fill: "none",
      fillOpacity: 0.3858268,
      stroke: "#00000f",
      strokeWidth: 3.76470613,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline",
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      opacity: 0.15400002,
      fill: "none",
      stroke: "#fff",
      strokeWidth: 1.63784266,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1,
      enableBackground: "new"
    },
    d: "m11.89 268.55 15.457-15.457",
    transform: "translate(14 -14)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m36 250-8 8",
    style: {
      fill: "none",
      stroke: "#949390",
      strokeWidth: 6,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    transform: "translate(14 -14)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#d5d3cf",
      strokeWidth: 6,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    d: "m36 248-8 8",
    transform: "translate(14 -14)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#241f31",
      strokeWidth: 12,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m28 258-14 14",
    transform: "translate(14 -14)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28 256-14 14",
    style: {
      fill: "none",
      stroke: "#424048",
      strokeWidth: 12,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(14 -14)"
  })), /*#__PURE__*/React.createElement("circle", {
    transform: "scale(-1 1)",
    r: 29.938,
    style: {
      display: "inline",
      opacity: 0.5,
      vectorEffect: "none",
      fill: "#fff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.44194174,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      enableBackground: "new"
    },
    cx: -72,
    cy: 212.062
  }), /*#__PURE__*/React.createElement("circle", {
    r: 30.118,
    cy: 214,
    cx: 72,
    style: {
      opacity: 1,
      fill: "none",
      fillOpacity: 0.3858268,
      stroke: "#1a5fb4",
      strokeWidth: 3.76470613,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      opacity: 1,
      fill: "none",
      fillOpacity: 0.3858268,
      stroke: "#62a0ea",
      strokeWidth: 3.76470613,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    },
    cx: 72,
    cy: 212,
    r: 30.118
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      opacity: 0.15400002,
      fill: "none",
      stroke: "#fff",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1,
      enableBackground: "new"
    },
    d: "m25 255 16-16"
  })), /*#__PURE__*/React.createElement("rect", {
    clipPath: "url(#d)",
    transform: "matrix(0 1 1 0 0 0)",
    ry: 8,
    rx: 8,
    y: 88,
    x: 252,
    height: 36,
    width: 36,
    style: {
      display: "inline",
      opacity: 1,
      fill: "url(#e)",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      marker: "none",
      markerStart: "none",
      markerMid: "none",
      markerEnd: "none",
      paintOrder: "normal",
      enableBackground: "new"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogsIconWikimedia);
export default __webpack_public_path__ + "static/media/logs_icon_wikimedia.08b505664db18a3a010ad7611cc9972f.svg";
export { ForwardRef as ReactComponent };